import { useGetRole } from 'hooks/ui/useGetRole';
import Collapse from './Collapse';
import Link from './Link';
import Section from './Section';
import { useGetAllPermissionsList } from 'hooks/ui/usePermissions';
import { SidebarMenuItemType } from 'hooks/ui/useSidebarMenuItems';

type Props = {
  item: SidebarMenuItemType;
};

const NavigationItem: React.FC<Props> = ({ item }) => {
  const { roleSlug } = useGetRole();
  const permissionsList = useGetAllPermissionsList();

  const isPermittedForRole = item.onlyShownForRoles?.length
    ? item.onlyShownForRoles?.includes(roleSlug ?? '')
    : true;

  const isHiddenForRole = item.hiddenForRoles?.length
    ? item.hiddenForRoles.includes(roleSlug ?? '')
    : false;

  const permissionOk = item.anyOfPermissions?.length
    ? item.anyOfPermissions.some((p) => permissionsList?.includes(p))
    : item.permission
    ? permissionsList?.includes(item.permission)
    : true;

  if (!isPermittedForRole || isHiddenForRole || !permissionOk) {
    return null;
  }

  switch (item.type) {
    case 'section':
      return <Section {...item} />;
    case 'collapse':
      return <Collapse {...item} />;
    case 'item':
      return <Link {...item} />;
    default:
      return null;
  }
};

export default NavigationItem;
